import { Component, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: []
})
export class CookiePolicyComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService, private elementRef:ElementRef) { }

  ngAfterViewInit() {
	var s = document.createElement("script");
	s.type = "text/javascript";
	s.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
	s.charset = "UTF-8";
	s.setAttribute('data-domain-script', '63456d2f-0ab4-4bb1-b3bf-02f31dbffc73');
	this.elementRef.nativeElement.appendChild(s);
  }

  ngOnInit() {
  	let t:string ="Cookie Policy | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Política de Cookies | Sinuberase",
  		description: "Política De Cookies",
  		slug: "Politica-de-Cookies"
  	})

  	this.seo.closeMenu();
  }

}
